export default __webpack_public_path__ + "7daa76f9be9e9f7b1337765f3027bb2f.jpg";